export const NON_BREAKABLE_SPACE = String.fromCharCode(160); // "\xa0";

export const JOTFORM_URL = "https://suno.jotform.com/";

export const WORD_PROCESSOR_DELIVERED_AT_DATE = new Date("2023-08-20");
